export default {"src":"/_next/static/media/demo-rich-tags.273564cf.gif","height":360,"width":640};